const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_BASE_URL,
};

export default config;
